import { render, staticRenderFns } from "./IconOfficeBuildingSolid.vue?vue&type=template&id=5b75a266"
import script from "./IconOfficeBuildingSolid.vue?vue&type=script&lang=js"
export * from "./IconOfficeBuildingSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports